import traceabilityCheck from './traceabilityCheck'
import menuAnchorHandler from './menu'

function global() {
  traceabilityCheck()
  menuAnchorHandler()
}

export default global
